import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./NavBar.module.css";
import logo from "../assets/logo.png";

const NavBar = ({ user, setUser }) => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setDropdownOpen(false);
    }, 250); // 延迟250毫秒隐藏菜单
  };

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    setUser(null);
    navigate("/");
  };

  const handleProfile = () => {
    navigate("profile");
  };

  const handleHome = () => {
    navigate("/");
  };

  return (
    <>
      <nav className={styles.navbar}>
        <div className={styles.container}>
          <div className={styles.brand} onClick={handleHome} style={{ cursor: "pointer" }}>
            <img src={logo} alt="企業ロゴ" className={styles.logo} />
            <h3 className={styles.title}>業務自動化診断・シミュレーション</h3>
          </div>
          <div className={styles.userSection}>
            {user ? (
              <div
                className={styles.userDropdown}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <span className={styles.userEmail}>{user.email}</span>
                <div className={`${styles.dropdownMenu} ${dropdownOpen ? styles.show : ""}`}>
                  <button onClick={handleProfile} className={styles.dropdownItem}>
                    プロフィール
                  </button>
                  <button onClick={handleLogout} className={styles.dropdownItem}>
                    ログアウト
                  </button>
                </div>
              </div>
            ) : (
              <span className={styles.notRegistered}>未登録</span>
            )}
          </div>
        </div>
      </nav>

      {/* 占位符，防止页面内容被导航栏覆盖 */}
      <div className={styles.navbarPlaceholder}></div>
    </>
  );
};

export default NavBar;
